export enum NotificationConstants {
  DocumentConverted = 'DocumentConverted',
  FilingConfirmation = 'FilingConfirmation',
  FilingPreview = 'FilingPreview',
  MdoReviewDecision = 'MDOReviewDecision',
  DocumentPreviewComplete = 'DocumentPreviewComplete',
  ImeRequestComplete = 'ImeRequestComplete',
  PermissionsUpdated = 'PermissionsUpdated',
  DocumentUploadComplete = 'DocumentUploadComplete',
  DocumentsUploaded = 'DocumentsUploaded',
  DocumentDownload = 'DocumentDownload',
  DocumentDownloadWithChildren = 'DocumentDownloadWithChildren',
  Print = 'Print',
  AutoDownload = 'AutoDownload',
  BulkDownloadComplete = 'BulkDownloadComplete',
}
